import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getOrganizationSubscriptions } from '@/features/billing/api/get-organization-subscriptions'

export function organizationSubscriptionsQueryKey(organizationId: number) {
  return ['organizations', organizationId, 'subscriptions'] as const
}

export function useOrganizationSubscriptions(
  organizationId: MaybeRefOrGetter<number>,
  options: { enabled?: MaybeRefOrGetter<boolean> } = {},
) {
  return useQuery({
    queryKey: computed(() => organizationSubscriptionsQueryKey(toValue(organizationId))),
    queryFn: () => getOrganizationSubscriptions(toValue(organizationId)),
    enabled: computed(() => toValue(options.enabled ?? true)),
  })
}
